<template>
  <v-app id="inspire">
    <CustomDrawer />
    <v-content style="background: rgba(150, 153, 156, 0.15)">
      <CustomNavbar />
      <v-container fluid class="px-3">
        <router-view />
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
import CustomNavbar from "./Toolbar";
import CustomDrawer from "./Drawer";
export default {
  components: {
    CustomNavbar,
    CustomDrawer,
  },
  props: {
    source: String,
  },
  created() {
    this.getAuthUser();
  },
  methods: {
    async getAuthUser() {
      try {
        await this.$store.dispatch("auth/GET_LOGIN_USER");
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>